import { render, staticRenderFns } from "./CardListSimple.vue?vue&type=template&id=05a048f0&scoped=true&"
import script from "./CardListSimple.vue?vue&type=script&lang=js&"
export * from "./CardListSimple.vue?vue&type=script&lang=js&"
import style0 from "./CardListSimple.vue?vue&type=style&index=0&id=05a048f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a048f0",
  null
  
)

export default component.exports